import {Component} from '@angular/core';
import {ActivatedRoute, Data, NavigationEnd, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {animate, group, query, style, transition, trigger} from '@angular/animations';
import { MetaService } from './Services/meta.service';
import { filter, map, mergeMap, tap } from 'rxjs/operators';

declare var gtag: Function;
declare var fbq: Function;

export const routeStateTrigger = trigger('routeState', [
  transition('* => *', [
    query(':enter', [
        style({opacity: 0})
      ], {optional: true}
    ),
    group([
      query(':leave', [
          animate(300, style({opacity: 0}))
        ],
        {optional: true}
      ),
      query(':enter', [
          style({opacity: 0}),
          animate(300, style({opacity: 1}))
        ],
        {optional: true}
      )
    ])
  ])
]);


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  // animations: routeStateTrigger,
})

export class AppComponent {

  constructor(
    public router: Router, 
    public translateProvider: TranslateService,
    private activatedRoute: ActivatedRoute,
    private metaService: MetaService
    ) {

    this.translateProvider.setDefaultLang('br');
    router.events.subscribe(async (y: NavigationEnd) => {
      if (y instanceof NavigationEnd) {
      // gtag('config', 'UA-108762810-3', { 'page_path': y.url });
      // fbq('track', 'PageView');
      }
    });

    // Meta data and Title of page
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter((route) => route.outlet === 'primary'),
        mergeMap((route) => route.data),
        tap(({title, metaTitle, ogTitle, description, ogDescription}: Data) => {
           this.metaService.updateTitle(title);
           this.metaService.updateMetaTitle(metaTitle);
           this.metaService.updateOgTitle(ogTitle);
           this.metaService.updateDescription(description);
           this.metaService.updateOgDescription(ogDescription);
         })
      ).subscribe();
  }
}
